<template>
    <div>

        <div class="backgroundStyle"></div>
        <div id="IntroductInformarion" class="IntroductInformarionPage" style="opacity: 1;position: relative;">
            <div class="firstIntroduction">F means a fundamental hardware lab located at the fourth floor
                ，fighting forward.
            </div>
            <div class="firstAnsuare">Get to know me.</div>

            <a href="javascript:;" class="LeftArrow" id="LeftArrow3" style="bottom: 2.1vw;" @click="ArrawClick()"></a>
            <a href="javascript:;" class="LeftArrow" id="LeftArrow2" style="bottom: 1.3vw;" @click="ArrawClick()"></a>
            <a href="javascript:;" class="LeftArrow" id="LeftArrow1" @click="ArrawClick()"></a>


        </div>
        <div class="IntroductInformarionPage">
            <div class="Problem">Who are we?</div>
            <div class="Ansuare">F-Lab is comprised of scholars who create a learning community that teaches workshops and
                offers consultations. Join us!</div>
        </div>
        <div class="IntroductInformarionPage">

            <div class="Problem">What we do?</div>
            <div class="Ansuare">F-Lab continues to lead the industry in the direction of innovation and is committed to
                training the next generation of electronic engineers.</div>
        </div>
        <div class="IntroductInformarionPage">

            <div class="Problem">Who we serve?</div>
            <div class="Ansuare">F-Lab research results are not only applied in academic fields, but also actively involved
                in solving practical problems in industry.</div>

        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            ScallorCout: 0,
        }
    },
    methods: {
        ArrawClick() {
            PageList = document.querySelectorAll(".IntroductInformarionPage");
            console.log(PageList)

            DivHeight = PageList[0].offsetHeight
            // PageList[1].scrollIntoView()
            var Len = 0
            var setp = DivHeight / 100
            var ScrollInterval = setInterval(() => {
                Len = Len + setp
                if (Len >= DivHeight) {
                    clearInterval(ScrollInterval)
                }
                document.documentElement.scrollTop = Len

            }, 5);
        }
    },
}
var OldScrollValue = 0
window.onscroll = function ScrollEvent() {
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // console.log(scrollTop)

    PageList = document.querySelectorAll(".IntroductInformarionPage");
    // console.log(PageList)

    DivHeight = PageList[0].offsetHeight

    if (scrollTop - OldScrollValue > 0) {

        var index = Math.floor(scrollTop / DivHeight);
        var op = scrollTop % DivHeight
        var Pre = op / DivHeight

        console.log(index, Pre, op, PageList[index])
        PageList[index + 1].style.opacity = Pre.toFixed(2)
        PageList[index].style.opacity = 1 - Pre.toFixed(2)


    }
    if (scrollTop - OldScrollValue < 0) {
        console.log('上滑')
        var index = Math.floor(scrollTop / DivHeight);
        var op = scrollTop % DivHeight
        var Pre = op / DivHeight

        console.log(index, Pre, op, PageList[index])
        PageList[index + 1].style.opacity = Pre.toFixed(2)
        PageList[index].style.opacity = 1 - Pre.toFixed(2)
        // console.log(index, Pre.toFixed(2))
    }
    OldScrollValue = scrollTop

}
</script>
<style scoped>
/* html,
body {
    padding: 0px;
    margin: 0px;
    background-color: #efefef;
    height: 100%;
    width: 100%;
} */

.backgroundStyle {
    min-height: 100%;

    width: 100%;
    position: fixed;

    top: 0;
    left: 0;
    /* background-color: aqua; */
    z-index: -1;
    font-family: Arial, 'Times New Roman', 'Microsoft YaHei', SimHei;
    font: bold 12px/0.75em Arial, 'Times New Roman', 'Microsoft YaHei', SimHei;
    background-image: url(../assets/zawadi_cropped_0.jpeg);
    background-size: cover;
}



.IntroductInformarionFirst,
.IntroductInformarionPage {
    box-sizing: border-box;
    position: relative;
    z-index: 99;
    box-sizing: border-box;
    /* border: 1px solid black; */
    min-height: 100%;
    /* height: 100%; */
    width: 98%;
    /* padding: 0 20px; */

    opacity: 0;
    margin: 0 auto;
    font-family: 'Times New Roman', Times, serif;
    padding-top: 30px;
    color: #fff;
    /* white-space: nowrap; */
    /* font-family: Arial, 'Times New Roman', 'Microsoft YaHei', SimHei; */
    /* font: bold 12px/0.75em Arial, 'Times New Roman', 'Microsoft YaHei', SimHei; */
    /* background-image: url(../static/20211107.jpg); */
    /* background-size: cover;
    background-repeat: no-repeat;
    background-position: center; */
    overflow: hidden;
    /* backdrop-filter: blur(100px); */
    /* filter: blur(3px); */


}

.Problem {
    /* font-size: 150px; */
    font-size: 8vw;
    -webkit-font-smoothing: antialiased;
}

.Ansuare {
    font-size: 3vw;

}

.firstIntroduction {
    font-size: 5vw;
    text-align: center;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);


    /* position: absolute;
    bottom: 100px; */
}

.firstAnsuare {
    width: 100%;
    font-size: 4vw;
    text-align: center;
    position: absolute;
    bottom: 4vw;
    margin: 0 auto;
    /* right: 50%;
    transform: translate(-50%, 0); */
}


@keyframes ArrowColor {
    from {
        border-color: #fff;
    }

    50% {
        border-color: aqua;
    }

    to {
        border-color: #fff;
    }
}



.LeftArrow,
.RightArrow {
    /* display: none; */
    position: absolute;
    /* top: 50%;
    margin-top: -20px; */



    width: 2vw;
    height: 2vw;
    /* background: rgba(0, 0, 0, 0.3); */
    text-align: center;
    line-height: 40px;
    color: #fff;
    font-family: "微软雅黑";
    font-size: 18px;
    z-index: 2;
    text-decoration: none;
    right: 50%;
    bottom: 0.5vw;
    transform: translate(-50%, 0);

}



.RightArrow {
    /* right: 20px; */
    border-top: 5px solid #fff;
    border-right: 5px solid #fff;
    transform: rotate(-45deg);
    /* margin-right: px; */
}

.LeftArrow {
    /* left: 20px; */
    border-left: 0.3vw solid #fff;
    border-bottom: 0.3vw solid #fff;

    transform: rotate(-45deg);
    /* margin-left: 20px; */
}


#LeftArrow3 {
    animation-name: ArrowColor;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-delay: 0.3s;
}

#LeftArrow2 {
    animation-name: ArrowColor;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-delay: 0.6s;
}

#LeftArrow1 {
    animation-name: ArrowColor;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-delay: 0.9s;
}
</style>


// WEBPACK FOOTER //
// src/components/Introduction.vue